import styled from "styled-components";

export const StarsStyles = styled.span`
  display: inline-flex;
  gap: 1px;
  align-items: center;
  color: #e0a800;
  line-height: 0;
`;
